import React from 'react';
import { Card, CardContent, Tab, Tabs } from '@mui/material';
import { FinancialPeriodFilter } from './FinancialPeriodFilter';
import { DashboardTabPanel } from './DashboardTabPanel';
import { OverviewTabWeb } from './tabs/OverviewTabWeb';
import { CategoriesTab } from './tabs/CategoriesTab';
import { GoalsTabWeb } from './tabs/GoalsTabWeb';
import { dashboardTabs, useFinancialDashboardScreen } from './hooks/useFinancialDashboardScreen';

export default function FinancialDashboardWeb() {
  const {
    period,
    selectedDate,
    setSelectedDate,
    viewByYear,
    setViewByYear,
    viewAllPeriod,
    setViewAllPeriod,
    activeTab,
    changeTab,
  } = useFinancialDashboardScreen();

  return (
    <Card elevation={3} sx={{ borderRadius: 4, bgcolor: 'background.paper' }}>
      <CardContent>
        <FinancialPeriodFilter
          selectedDate={selectedDate}
          onChange={setSelectedDate}
          viewByYear={viewByYear}
          onToggleViewByYear={setViewByYear}
          viewAllPeriod={viewAllPeriod}
          onToggleViewAllPeriod={setViewAllPeriod}
        />

        <Tabs
          value={activeTab}
          onChange={(_, tab) => changeTab(tab)}
          sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="Visão Geral" value={dashboardTabs.OVERVIEW} />
          <Tab label="Categorias" value={dashboardTabs.CATEGORIES} />
          <Tab label="Metas" value={dashboardTabs.GOALS} />
        </Tabs>

        <DashboardTabPanel index={dashboardTabs.OVERVIEW} activeTab={activeTab}>
          <OverviewTabWeb period={period} />
        </DashboardTabPanel>

        <DashboardTabPanel index={dashboardTabs.CATEGORIES} activeTab={activeTab}>
          <CategoriesTab period={period} />
        </DashboardTabPanel>

        <DashboardTabPanel index={dashboardTabs.GOALS} activeTab={activeTab}>
          <GoalsTabWeb period={period} />
        </DashboardTabPanel>
      </CardContent>
    </Card>
  );
}
